import axios from 'axios'

export default {
  /**
   * 查询当前登录用户的律所是否在白名单中
   * @return  一个Boolean 状态值
   */
  getInWhiteList () {
    return axios.get('/taskserver/api/v2/timing/inWhiteList', {})
  },
  /**
   * 获取计时详情列表
   * @return {Promise<AxiosResponse<T>>}
   */
  getTimingDetailsLists (params) {
    return axios.get('/taskserver/api/v2/timing/timing/search', { params: params })
  },
  /**
   * 获取该账号下可以查看其它成员计时的列表
   * @return {Promise<AxiosResponse<T>>}
   */
  getTimingMemberLists (params) {
    return axios.get('/taskserver/api/v2/timing/timing/peopleTimingInfo', { params: params })
  },
  /**
   * 获取任务动态下的列表
   * @return {Promise<AxiosResponse<T>>}
   */
  getTaskDynamicLists (params) {
    return axios.get('/matterserver/api/v1/homePage/orgDynamic', { params: params })
  },
  /**
   * 判断文档动态下文件是否删除
   * @return {Promise<AxiosResponse<T>>}
   */
  judgeDocumentIsDelete (params) {
    return axios.get('/matterserver/api/v2/matter/files/detail', { params: params })
  },
  // 获取文件size
  getDocumentSize (id, params) {
    return axios.put('/matterserver/api/v1/homePage/updateDynamics/' + id, params)
  }
}
